<mat-dialog-content>
  <lemon-dialog-header> Kirjauksen raakadata </lemon-dialog-header>

  <h3 style="margin: 0">Urit</h3>
  <div style="padding-top: 1em; padding-left: 1em; padding-right: 1em">
    Kirjaus: <a [href]="kirjausEncodedUriObservable | async" target="_BLANK">{{ kirjausUriObservable | async }}</a>
  </div>
  <div style="padding-top: 0; padding-left: 1em; padding-right: 1em">
    Liitetyt tiedostot: <a [href]="kirjaukseenLiitettyjenTiedostojenEncodedUriObservable | async" target="_BLANK">{{ kirjaukseenLiitettyjenTiedostojenUriObservable | async }}</a>
  </div>
  @for (selvityspyynto of selvityspyynnonUritObservable | async; track selvityspyynto.uri) {
    <div style="padding-top: 0; padding-left: 1em; padding-right: 1em">
      Uusi selvityspyyntö: <a [href]="selvityspyynto.encodedUri" target="_BLANK">{{ selvityspyynto.uri }}</a>
    </div>
  }

  <h3 style="margin: 0; margin-top: 1em">Kirjaus</h3>
  <div style="padding: 1em 1em 0 1em">
    <strong>Tiedot:</strong>
    @if (kirjauksenToimittajatObservable | async; as toimittajat) {
      <div>Toimittajat:</div>
      @for (toimittaja of toimittajat; track $index) {
        <div style="padding-left: 1em">{{ toimittaja }}</div>
      } @empty {
        <div style="padding-left: 1em">Ei toimittajia</div>
      }
    }
  </div>
  <div style="padding: 1em 1em 0 1em"><strong>Raakadata:</strong></div>
  <div style="padding: 1em" [innerHTML]="data.naytettavaKirjaus | ljson"></div>

  <h3 style="margin: 0; margin-top: 1em">Liitetyt tiedostot</h3>
  <div style="padding: 1em" [innerHTML]="liitetytTiedostotObservable | async | ljson"></div>
</mat-dialog-content>
<mat-dialog-actions>
  <app-secondary-button [focusRegionStart]="true" mat-dialog-close actionId="Peruuta (kirjauksen raakadata dialog)">{{ 'yleiset.peruuta' | translate | async }}</app-secondary-button>
</mat-dialog-actions>
